import { useEffect, useState } from "react";

/**
 * Tracks the viewer's `prefers-reduced-motion` setting.
 *
 * The CSS in this page already opts out of its own animations, but Recharts
 * animates its series from JavaScript and ignores the media query, so the
 * chart needs to be told explicitly.
 */
export function useReducedMotion() {
  const [reduced, setReduced] = useState(() => {
    if (typeof window === "undefined" || !window.matchMedia) return false;
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  });

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return undefined;

    const query = window.matchMedia("(prefers-reduced-motion: reduce)");
    const onChange = (event) => setReduced(event.matches);

    // Safari below 14 only has the deprecated add/removeListener pair.
    if (query.addEventListener) {
      query.addEventListener("change", onChange);
      return () => query.removeEventListener("change", onChange);
    }
    query.addListener(onChange);
    return () => query.removeListener(onChange);
  }, []);

  return reduced;
}
